// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Mixins **/
/** Vars (common) **/
/** app colors **/
/** Vars (MuiAlert) **/
/** main classes **/
.NibFileSelector_old-container__R-Io9 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.NibFileSelector_old-container__R-Io9.NibFileSelector_wrap__VE7sE {
  flex-wrap: wrap;
}
.NibFileSelector_old-container__R-Io9 .NibFileSelector_box__ZI8FW.NibFileSelector_col__H\\+Qoa {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
}
.NibFileSelector_old-container__R-Io9 .NibFileSelector_box__ZI8FW.NibFileSelector_col__H\\+Qoa > div {
  width: 100%;
}
.NibFileSelector_old-container__R-Io9 .NibFileSelector_box__ZI8FW.NibFileSelector_row__VHJ8L {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.NibFileSelector_old-container__R-Io9 form {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
}
.NibFileSelector_old-container__R-Io9 form > .NibFileSelector_box__ZI8FW.NibFileSelector_col__H\\+Qoa {
  flex-basis: 33.33%;
}
@media screen and (min-width: 2560px) {
  .NibFileSelector_old-container__R-Io9 form > .NibFileSelector_box__ZI8FW.NibFileSelector_col__H\\+Qoa {
    flex-basis: 0%;
    margin-right: 2em;
  }
}

@media screen and (max-width: 580px) {
  .NibFileSelector_old-container__R-Io9, .NibFileSelector_col__H\\+Qoa, form {
    padding: 5px;
  }
}
@media screen and (max-width: 450px) {
  .NibFileSelector_old-container__R-Io9, .NibFileSelector_col__H\\+Qoa, form {
    padding: 0px;
  }
}
.NibFileSelector_text-overflow-hidden__UnHfo {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.NibFileSelector_icon__fJmVD {
  color: var(--accent-color);
}

.NibFileSelector_richtext-output-wrap__i6S4M .NibFileSelector_se-video-container__y6PsC figure {
  padding-bottom: 0 !important;
}

.NibFileSelector_uploadWrap__hq7s9 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./src/sass/_settings.sass","webpack://./src/components/common/NibFileSelector/NibFileSelector.module.sass"],"names":[],"mappings":"AAAA,aAAA;AAeA,oBAAA;AAgBA,iBAAA;AA0BA,sBAAA;AAGA,mBAAA;AACA;EA3DE,aAAA;EACA,mBA4DM;EA3DN,8BA2DW;EA1DX,uBA0D0B;EAC1B,kBAAA;EACA,WAAA;ACrDF;ADsDE;EACE,eAAA;ACpDJ;ADsDI;EAnEF,aAAA;EACA,sBAmEU;EAlEV,2BAkEkB;EAjElB,uBAiE8B;EAC1B,eAAA;ACjDN;ADkDM;EACE,WAAA;AChDR;ADiDI;EAxEF,aAAA;EACA,mBAwEU;EAvEV,2BAuEe;EAtEf,uBAsE2B;EACvB,WAAA;AC5CN;AD6CE;EACE,aAjDK;EA3BP,aAAA;EACA,mBA4EQ;EA3ER,2BA2Ea;EA1Eb,uBA0EyB;EACvB,kBAAA;EACA,eAAA;EACA,WAAA;ACxCJ;ADyCI;EACE,kBAAA;ACvCN;ADwCM;EAFF;IAGI,cAAA;IACA,iBAAA;ECrCN;AACF;;ADsCA;EAEE;IACE,YAFO;EClCT;AACF;ADoCA;EAEE;IACE,YAFO;ECjCT;AACF;ADoCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AClCF;;ADoCA;EACE,0BAtFO;ACqDT;;ADqCI;EACE,4BAAA;AClCN;;AAzEA;EDAE,aAAA;EACA,mBAAA;EACA,yBCDa;EDEb,mBCFuB;EACrB,eAAA;AA+EJ","sourcesContent":["/** Mixins **/\n=flex($der, $justy, $align)\n  display: flex\n  flex-direction: $der\n  justify-content: $justy\n  align-items: $align\n\n=shadow()\n  box-shadow: -5px 5px 10px 0px rgba(#000, .35)\n\n=staticHeight($height)\n  min-height: $height\n  max-height: $height\n  height: $height\n\n/** Vars (common) **/\n$main: #2F2F2F\n$main_background: #191818\n$accent: var(--accent-color)\n$accent_text: var(--accent-text-color)\n$accent_r: var(--accent-color-r)\n$accent_g: var(--accent-color-g)\n$accent_g10: var(--accent-color-g10)\n$accent_b: var(--accent-color-b)\n$text: #cecece\n$error: #f44336\n$success: rgb(102, 187, 106)\n$container_background_color: #1B1B1B\n$container_item_background_color: #212121\n$gutter: 20px\n\n/** app colors **/\n$soft_teal: #84aaaf\n$fiery_red: #ff3131\n$muted_red: #e85a4f\n$app_red: #B83336\n$soft_creamy: #f5e8dd\n$light_gray: #535353\n$golden_yellow: #ffc107\n$orange: #ffa725\n$app_orange: #DB890E\n$warm_orange: #e3a869\n$faded_pink: #d69fa2\n$purple: #8868a3\n$app_purple: #7E51A3\n$light_blue: #79a8d1\n$app_green: #16962F\n$retro_green: #4a7c59\n$deep_blue: #406ca8\n\n$main_block_top_padding: 130px\n$main_block_top_padding_s: 70px\n$header_height: 120px\n$sidebar_width: 320px\n\n$table_row_height: 55px\n\n/** Vars (MuiAlert) **/\n$MuiAlert_main_color: rgb(166, 213, 250)\n\n/** main classes **/\n.old-container\n  //padding: $gutter\n  +flex(row, space-between, flex-start)\n  position: relative\n  width: 100%\n  &.wrap\n    flex-wrap: wrap\n  .box\n    &.col\n      +flex(column, flex-start, flex-start)\n      padding: 0 calc($gutter/2)\n      > div\n        width: 100%\n    &.row\n      +flex(row, flex-start, flex-start)\n      width: 100%\n  form\n    padding: $gutter\n    +flex(row, flex-start, flex-start)\n    position: relative\n    flex-wrap: wrap\n    width: 100%\n    > .box.col\n      flex-basis: 33.33%\n      @media screen and ( min-width: 2560px )\n        flex-basis: 0%\n        margin-right: 2em\n\n@media screen and ( max-width: 580px )\n  $gutter: 5px\n  .old-container, .col, form\n    padding: $gutter\n@media screen and ( max-width: 450px )\n  $gutter: 0px\n  .old-container, .col, form\n    padding: $gutter\n\n.text-overflow-hidden\n  overflow: hidden\n  text-overflow: ellipsis\n  white-space: nowrap\n\n.icon\n  color: $accent\n\n.richtext-output-wrap\n  .se-video-container\n    figure\n      padding-bottom: 0 !important\n","@import '../../../sass/_settings'\n\n.uploadWrap\n    +flex(row, flex-end, center)\n    flex-wrap: wrap"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"old-container": `NibFileSelector_old-container__R-Io9`,
	"wrap": `NibFileSelector_wrap__VE7sE`,
	"box": `NibFileSelector_box__ZI8FW`,
	"col": `NibFileSelector_col__H+Qoa`,
	"row": `NibFileSelector_row__VHJ8L`,
	"text-overflow-hidden": `NibFileSelector_text-overflow-hidden__UnHfo`,
	"icon": `NibFileSelector_icon__fJmVD`,
	"richtext-output-wrap": `NibFileSelector_richtext-output-wrap__i6S4M`,
	"se-video-container": `NibFileSelector_se-video-container__y6PsC`,
	"uploadWrap": `NibFileSelector_uploadWrap__hq7s9`
};
export default ___CSS_LOADER_EXPORT___;
